<template>
<div class="quiz_progress">

<div  class="quiz_progress_home_item">
<div class="quiz_progress_item_inner animate_class"  @click="gotoHome()">

<i class="pi pi-spin pi-spinner mt-2 " style="font-size: 1em;" v-if="loading"></i>
<i class="pi pi-home" v-else></i>
</div>
</div>

<div  class="quiz_progress_home_item">
<template v-if="$route.name=='EvaluationProgress'">
<div class="quiz_progress_item_inner quiz_progress_item_inner_active animate_class"  @click="gotoList()">
<i class="pi pi-list"></i>
</div>
</template>
<template v-else>
<div class="quiz_progress_item_inner animate_class"  @click="gotoList()">
<i class="pi pi-list"></i>
</div>  
</template>
</div>


<FlowProcess></FlowProcess>

<!--
<div v-for="item in $store.state.evaluation.parentsections" class="quiz_progress_item">
<template v-if="item.id == $store.state.evaluation.active_parent_section_id">
<div class="quiz_progress_item_inner quiz_progress_item_inner_active animate_class"  @click="gotoSection(item.id)">
<p class="mt-0 mb-0" v-for="element in item.translations" v-show="element.language_id == $store.state.auth.user.preflang_id">{{element.translation}}</p>
</div>	
</template>
<template v-else>
<div class="quiz_progress_item_inner animate_class"  @click="gotoSection(item.id)">
<p class="mt-0 mb-0" v-for="element in item.translations" v-show="element.language_id == $store.state.auth.user.preflang_id">{{element.translation}}</p>
</div>	
</template>

</div>

-->




</div>

</template>

<script>
export default {

  name: 'QuizProgress',
  data () {
    return {
      loading:false
    }
  },
  methods:{
  	gotoSection(id)
  	{	
  		this.$store.dispatch('evaluation/setActiveParentSectionId',id) 
  		this.$router.push({ name: 'EvaluationSection', params: { section_id:id } })
  	},
  	async gotoHome()
    {
      console.log(this.$store.state.auth.user)
      
      let userroles = await this.$store.state.auth.user.userroles
      let roletype = "admin"
      for(let i=0; i<userroles.length;i++)
      {
        if(userroles[i].name=="supplier")
        {
          roletype = "supplier"
          break;
        }
       
      }
      this.loading = await true
      //console.log(this.$store.state.evaluation.evaluation)
      let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+this.$store.state.evaluation.evaluation.uuid)
      
      this.loading = await true
      //return false
      if(roletype=="supplier")
      {
        await this.$router.push({ name: 'SupplierBrandFlowSummary',params:{supplier_uuid:projectsupplier.supplier.uuid,project_id:projectsupplier.uuid,flow_id:this.$store.state.evaluation.evaluation.uuid} })
      }
      else
      {
        await this.$router.push({ name: 'SupplierProjectFlowSummary',params:{id:projectsupplier.supplier_id,project_id:projectsupplier.uuid,flow_id:this.$store.state.evaluation.evaluation.uuid} })
      }
      

      /*
      if(this.$store.state.evaluation.active_project_supplier)
      {
        this.$router.push({ name: 'SupplierProjectDetail', params: { project_id:this.$store.state.evaluation.active_project_supplier } })
      }
      else
      {
        this.$router.push({ name: 'EvaluationInfo' })
      }
      */
      
    },
    gotoList()
    {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.$router.push({ name: 'EvaluationProgress' })
    },
  }
}
</script>

<style lang="css" scoped>
</style>